export default "__VITE_ASSET__BrKR$GIC__"